import { Snackbar, Alert } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { getIAStyles } from './iaDesign';

export default function SnackAlert(props) {
  const { setSnack, snack } = props;
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    const newSnack = { open: false, severity: null, message: null };
    setSnack(newSnack);
  };

  if (snack && snack.open) {
    const { severity, message, isAiResult } = snack;

    const aiStyles = {
      ...getIAStyles('snack'),
      background: 'white',
      minWidth: '300px',
      justifyContent: 'center'
    };
    return (
      <Snackbar
        open={true}
        autoHideDuration={isAiResult ? null : 6000}
        onClose={handleClose}
      >
        <Alert
          severity={severity}
          onClose={handleClose}
          icon={isAiResult ? <AutoAwesomeIcon /> : undefined}
          sx={isAiResult ? aiStyles : { width: '100%' }}
        >
          {message}
        </Alert>
      </Snackbar>
    );
  } else {
    return null;
  }
}
